// NPM Imports
// import amplitude from "amplitude-js";
// Internal Imports
import { EVENTS } from "../constants";

const amplitude =
  typeof window !== "undefined" ? require("amplitude-js") : null;
// import { getUniqueWorkflowApprovers } from "./documentUtils";

// // Declarations
// const { EVENT_NAMES } = EVENTS;

// Internal Functions
// const _amplitudeSetUserID = id => amplitude.getInstance().setUserId(id);

// const _amplitudeSetUserProperties = user => {
//   if (user && Object.keys(user).length > 0) {
//     amplitude.getInstance().setUserProperties(user);
//   } else {
//     amplitude.getInstance().setUserProperties({
//       name: null,
//       billing_plan: null,
//       organisation: null,
//       email: null,
//       roles: [],
//       onboardingUserRole: null,
//       companySize: null,
//     });
//   }
// };

// const _prepareProps = (event, eventProps) => {
//   let amplitudeProps;
//   switch (event) {
//     // case EVENT_NAMES.DOCUMENT_CREATED: {
//     //   const {
//     //     type: { name: documentType } = {},
//     //     created_from: createdFrom,
//     //     doc_no: documentID,
//     //     template_id: templateID,
//     //     initiatedFrom = "swimlane",
//     //     revision,
//     //   } = eventProps;
//     //   amplitudeProps = {
//     //     documentType,
//     //     createdFrom,
//     //     revision,
//     //     initiatedFrom,
//     //     documentID,
//     //     templateID,
//     //   };
//     //   return amplitudeProps;
//     // }
//     case EVENT_NAMES.TEMPLATE_CREATED: {
//       const {
//         type: { name: documentType } = {},
//         createdFrom,
//         template_id: templateID,
//         template_type: templateType,
//         fields_used: fieldsUsed,
//       } = eventProps;
//       amplitudeProps = {
//         documentType,
//         createdFrom,
//         templateType,
//         templateID,
//         form_fields: fieldsUsed ? fieldsUsed.length : 0,
//       };
//       return amplitudeProps;
//     }
//     case EVENT_NAMES.DOCUMENT_VIEWED: {
//       const {
//         initiatedFrom = "Asset",
//         id: documentID,
//         template_id: templateID,
//         // documentStatus: { name: status },
//         status = eventProps.documentStatus && eventProps.documentStatus.name,
//         tag = eventProps.documentTag && eventProps.documentTag.name,
//       } = eventProps;
//       amplitudeProps = {
//         initiatedFrom,
//         documentID,
//         templateID,
//         status,
//         tag,
//       };
//       return amplitudeProps;
//     }
//     case EVENT_NAMES.INTERNAL_REVIEW: {
//       const {
//         docNo,
//         revisionNo: revision,
//         id: documentID,
//         template_id: templateID,
//         status,
//         docAnalysis,
//         initiatedFrom,
//       } = eventProps;
//       amplitudeProps = {
//         docNo,
//         revision,
//         documentID,
//         templateID,
//         status,
//         workflowTrigger: docAnalysis.length > 0,
//         workflowNumber: docAnalysis.length,
//         workflowApprovers: getUniqueWorkflowApprovers(docAnalysis)
//           .uniqueApproversCount,
//         initiatedFrom,
//       };
//       return amplitudeProps;
//     }
//     case EVENT_NAMES.CUSTOMER_REVIEW: {
//       const {
//         docNo,
//         revisionNo: revision,
//         id: documentID,
//         template_id: templateID,
//         status,
//         initiatedFrom,
//         uploadRevision,
//         downloadType,
//         signatureBlockAdded,
//         signatories,
//       } = eventProps;
//       amplitudeProps = {
//         docNo,
//         revision,
//         documentID,
//         templateID,
//         status,
//         initiatedFrom,
//         uploadRevision,
//         downloadType,
//         signatureBlockAdded,
//         signatories,
//       };
//       return amplitudeProps;
//     }
//     case EVENT_NAMES.SIGNATORY_ADDED: {
//       const {
//         id: documentID,
//         template_id: templateID,
//         docType: documentType,
//         revisionNo: revision,
//         signatories,
//       } = eventProps;
//       amplitudeProps = {
//         documentID,
//         templateID,
//         documentType,
//         revision,
//         signatories,
//       };
//       return amplitudeProps;
//     }
//     case EVENT_NAMES.SIGNATURE_BLOCK_MISSED: {
//       const {
//         id: documentID,
//         template_id: templateID,
//         docType: documentType,
//         revisionNo: revision,
//       } = eventProps;
//       amplitudeProps = {
//         documentID,
//         templateID,
//         documentType,
//         revision,
//         missed: true,
//       };
//       return amplitudeProps;
//     }
//     case EVENT_NAMES.REVISION_UPLOADED: {
//       const {
//         id: documentID,
//         template_id: templateID,
//         docType: documentType,
//         revisionNo: revision,
//       } = eventProps;
//       amplitudeProps = {
//         documentID,
//         templateID,
//         documentType,
//         revision,
//       };
//       return amplitudeProps;
//     }
//     // case EVENT_NAMES.DOCUMENT_DOWNLOADED: {
//     //   const {
//     //     id: documentID,
//     //     template_id: templateID,
//     //     docType: documentType,
//     //     revisionNo: revision,
//     //     status,
//     //     downloadType,
//     //     stage,
//     //   } = eventProps;
//     //   amplitudeProps = {
//     //     documentID,
//     //     templateID,
//     //     documentType,
//     //     revision,
//     //     status,
//     //     downloadType,
//     //     swimlane: stage,
//     //   };
//     //   return amplitudeProps;
//     // }
//     case EVENT_NAMES.DOCUMENT_APPROVED: {
//       const {
//         id: documentID,
//         template_id: templateID,
//         docType: documentType,
//         revisionNo: revision,
//         documentNotesCount,
//       } = eventProps;
//       amplitudeProps = {
//         documentID,
//         templateID,
//         documentType,
//         revision,
//         commentAdded: documentNotesCount > 0,
//       };
//       return amplitudeProps;
//     }
//     case EVENT_NAMES.DOCUMENT_REJECTED: {
//       const {
//         id: documentID,
//         template_id: templateID,
//         docType: documentType,
//         revisionNo: revision,
//       } = eventProps;
//       amplitudeProps = {
//         documentID,
//         templateID,
//         documentType,
//         revision,
//       };
//       return amplitudeProps;
//     }
//     case EVENT_NAMES.DOCUMENT_SIGNED: {
//       const {
//         documentID,
//         templateID,
//         status,
//         initiatedFrom,
//         documentType,
//       } = eventProps;
//       amplitudeProps = {
//         documentID,
//         templateID,
//         status,
//         initiatedFrom,
//         documentType,
//       };
//       return amplitudeProps;
//     }
//     case EVENT_NAMES.USER_SIGNEDIN: {
//       return eventProps;
//     }
//     case EVENT_NAMES.USER_SIGNUP: {
//       return eventProps;
//     }
//     case EVENT_NAMES.SIGNUP_VIEWED: {
//       return {};
//     }
//     case EVENT_NAMES.PRO_FEATURE_ACCESSED: {
//       return eventProps;
//     }
//     case EVENT_NAMES.PRODUCT_ADDED: {
//       return eventProps;
//     }
//     case EVENT_NAMES.TEAMMATES_INVITED: {
//       return eventProps;
//     }
//     case EVENT_NAMES.DEAL_TABLE_GROUPING_APPLIED: {
//       return eventProps;
//     }
//     case EVENT_NAMES.DEAL_TABLE_GROUPING_MODIFIED: {
//       return eventProps;
//     }
//     case EVENT_NAMES.COMMENT_ADDED: {
//       return eventProps;
//     }
//     case EVENT_NAMES.WORKFLOW_DT_CREATED: {
//       return eventProps;
//     }
//     case EVENT_NAMES.WORKFLOW_CLAUSE_OPTION_CREATED: {
//       return eventProps;
//     }
//     case EVENT_NAMES.TEMPLATE_OPENED: {
//       return eventProps;
//     }
//     case EVENT_NAMES.TEMPLATE_CLONED: {
//       return eventProps;
//     }
//     case EVENT_NAMES.TEMPLATE_PUBLISHED: {
//       return eventProps;
//     }
//     case EVENT_NAMES.TEMPLATE_EDITED: {
//       return eventProps;
//     }
//     case EVENT_NAMES.TAGS_CHANGED: {
//       return eventProps;
//     }
//     case EVENT_NAMES.STATUS_CHANGED: {
//       return eventProps;
//     }
//     case EVENT_NAMES.NEW_TAG_ADDED: {
//       return eventProps;
//     }
//     case EVENT_NAMES.TAG_EDITED: {
//       return eventProps;
//     }
//     case EVENT_NAMES.NEW_STATUS_ADDED: {
//       return eventProps;
//     }
//     case EVENT_NAMES.CREATE_DOC_CLICKED: {
//       return eventProps;
//     }
//     case EVENT_NAMES.FOLDER_CREATED: {
//       return eventProps;
//     }
//     case EVENT_NAMES.FOLDER_DELETED: {
//       return eventProps;
//     }
//     case EVENT_NAMES.FOLDER_RENAMED: {
//       return eventProps;
//     }
//     case EVENT_NAMES.COLLABORATORS_ADDED_ON_FOLDER: {
//       return eventProps;
//     }
//     case EVENT_NAMES.DOCUMENT_DELETED: {
//       return eventProps;
//     }
//     case EVENT_NAMES.DOCUMENT_RENAMED: {
//       return eventProps;
//     }
//     case EVENT_NAMES.DOCUMENT_DOWNLOADED: {
//       return eventProps;
//     }
//     case EVENT_NAMES.DOCUMENT_CREATED: {
//       return eventProps;
//     }
//     case EVENT_NAMES.SHARE_DOCUMENT_CLICKED: {
//       return eventProps;
//     }
//     case EVENT_NAMES.DOCUMENT_SHARED: {
//       return eventProps;
//     }
//     case EVENT_NAMES.EDIT_DOCUMENT_CLICKED: {
//       return eventProps;
//     }
//     case EVENT_NAMES.GO_TO_POPUP_CLICKED: {
//       return eventProps;
//     }
//     case EVENT_NAMES.DOCUMENT_SENT_FOR_SIGNATURE: {
//       return eventProps;
//     }
//     case EVENT_NAMES.SIGNATURE_BLOCK_EDITED: {
//       return eventProps;
//     }
//     case EVENT_NAMES.SIGNER_ADDED: {
//       return eventProps;
//     }
//     case EVENT_NAMES.SIGNER_DELETED: {
//       return eventProps;
//     }
//     case EVENT_NAMES.ESIGN_BUTTON_CLICKED: {
//       return eventProps;
//     }
//     case EVENT_NAMES.TEMPLATE_PREVIEW_CLICKED: {
//       return eventProps;
//     }
//     case EVENT_NAMES.TEMPLATE_PREVIEW_CLOSED: {
//       return eventProps;
//     }
//     case EVENT_NAMES.ADD_TEMPLATE_BUTTON_CLICKED: {
//       return eventProps;
//     }
//     case EVENT_NAMES.TEMPLATE_TAGS_CHANGED: {
//       return eventProps;
//     }
//     case EVENT_NAMES.TEMPLATE_STATUS_CHANGED: {
//       return eventProps;
//     }
//     case EVENT_NAMES.TEMPLATE_DELETED: {
//       return eventProps;
//     }
//     case EVENT_NAMES.TEMPLATE_PREVIEW_NAVIGATION: {
//       return eventProps;
//     }
//     case EVENT_NAMES.DOCUMENT_PREVIEW_CLICKED: {
//       return eventProps;
//     }
//     case EVENT_NAMES.UNSPLASH_BUTTON_CLICKED: {
//       return eventProps;
//     }
//     case EVENT_NAMES.UNSPLASH_IMAGE_UPLOAD: {
//       return eventProps;
//     }
//     case EVENT_NAMES.UNSPLASH_LOAD_MORE_BUTTON_CLICKED: {
//       return eventProps;
//     }
//     case EVENT_NAMES.UNSPLASH_SEARCH_IMAGES: {
//       return eventProps;
//     }
//     case EVENT_NAMES.STRIPE_BLOCK_ADDED: {
//       return eventProps;
//     }
//     case EVENT_NAMES.STRIPE_BLOCK_SAVED: {
//       return eventProps;
//     }
//     case EVENT_NAMES.STRIPE_PAYMENT_BUTTON_CLICKED: {
//       return eventProps;
//     }
//     case EVENT_NAMES.METALENS_ACTIVE: {
//       return eventProps;
//     }
//     case EVENT_NAMES.METALENS_DOWNLOAD: {
//       return eventProps;
//     }
//     case EVENT_NAMES.METALENS_ADD_TAG: {
//       return eventProps;
//     }
//     case EVENT_NAMES.CLAUSE_ANALYSIS_RESET_FILTER:
//     case EVENT_NAMES.CLAUSE_ANALYSIS_FEEDBACK_SUBMITTED:
//     case EVENT_NAMES.CLAUSE_ANALYSIS_CLAUSE_FILTER_SELECTED:
//     case EVENT_NAMES.CLAUSE_ANALYSIS_REVIEW_TYPE_SELECTED: {
//       return eventProps;
//     }

//     default:
//       return {};
//   }
// };

// Exported Functions
export const amplitudeInit = () => {
  // if (user && Object.keys(user).length > 0) {
  //   _amplitudeSetUserID(user.userOrgId);
  //   _amplitudeSetUserProperties(user);
  // } else {
  //   _amplitudeSetUserID(null); // not string 'null'
  //   amplitude.getInstance().regenerateDeviceId();
  // }
};

export const amplitudeLogEvent = () => {
  // try {
  //   amplitude.getInstance().logEvent(event, _prepareProps(event, eventProps));
  // } catch (err) {
  //   console.error(`amplitudeUtils.js => amplitudeLogEvent => ${err}`);
  // }
};

const _preparePropsLZ = (event, eventProps) => {
  switch (event) {
    case EVENTS.EVENT_NAMES.REQUEST_NEW_LINK: {
      return eventProps;
    }
    case EVENTS.EVENT_NAMES.DECLINE_DOCUMENT: {
      return eventProps;
    }
    case EVENTS.EVENT_NAMES.ADOPT_SIGNATURE: {
      return eventProps;
    }
    case EVENTS.EVENT_NAMES.VIEW_SIGNING_PAGE: {
      return eventProps;
    }
    case EVENTS.EVENT_NAMES.CLICK_DECLINE: {
      return eventProps;
    }
    case EVENTS.EVENT_NAMES.CLICK_DOCUMENT_DETAILS: {
      return eventProps;
    }
    case EVENTS.EVENT_NAMES.CLICK_DOWNLOAD: {
      return eventProps;
    }
    case EVENTS.EVENT_NAMES.CLICK_START_SIGNING: {
      return eventProps;
    }
    case EVENTS.EVENT_NAMES.CLICK_FINISH_SIGNING: {
      return eventProps;
    }
    case EVENTS.EVENT_NAMES.CLICK_SIGN_TAG: {
      return eventProps;
    }
    case EVENTS.EVENT_NAMES.CLICK_EDIT_SIGNATURE: {
      return eventProps;
    }
    default:
      return {};
  }
};

export const amplitudeLogEventLZ = (event, eventProps) => {
  if (typeof window !== "undefined") {
    try {
      amplitude
        .getInstance()
        .logEvent(event, _preparePropsLZ(event, eventProps));
    } catch (err) {
      console.error(`amplitudeUtils.js => amplitudeLogEvent => ${err}`);
    }
  }
};
